document.addEventListener('DOMContentLoaded', function () {
  var viewer = document.querySelector('slider-component[id^="GalleryViewer"]');
  if (!viewer) return;

  var dots = document.querySelectorAll('.pdp-gallery-dots__dot');
  if (!dots.length) return;

  viewer.addEventListener('slideChanged', function (e) {
    var current = e.detail.currentPage;
    dots.forEach(function (dot, i) {
      dot.classList.toggle('pdp-gallery-dots__dot--active', i === current - 1);
    });
  });
});
